export default __webpack_public_path__ + "static/media/3l-act.33f40cef.svg";